export const watchlistItemTypes = {
  DOSSIER: 'dossier',
};
